import namespace from '@/helpers/namespace';

export default namespace('whiteLabel', {
  getters: [
    'listReservationTypes',
    'allEvents',
    'event',
    'loader',
    'disabledOnLog',
    'galleries',
    'categoriesMenu',
    'avalibilityHour',
    'selectedDate',
    'selectedHour',
    'selectedPeople',
    'selectedAdult',
    'selectedBoy',
    'selectedBaby',
    'selectedTypeReservation',
    'sendReservation',
    'send705',
    'paymentType',
    'isFree',
    'banks',
    'showMenu',
    'branch',
    'reservationsUser',
    'reservationsList',
    'reservationsExecuted',
    'editReservation',
    'cancelarReservation',
    'dataReservationEdit',
    'minimunPeoples',
    'times',
    'section',
    'showModalLogin',
    'showModalReservationConfirm',
    'showModalUpdateUser',
    'showModalPolitica',
    'loadHour',
    'reservationDayUser',
    'showCancelar',
    'getVendorAssociates',
    'reservationEvent',
    'avalabilityGroup',
    'isAvalability',
    'zones',
    'invite',
    'selectedZone',
    'selectedTable',
    'locked',
    'selectedExperience',
    'eventPrice',
    'loginProcessReservation',
    'popupAlertEvent',
    'getMenuIdBanner',
    'getListBannersMenu',
    'getExistBanner',
    'integrations',
    'integrationDefaults'
  ],
  actions: [
    'allEvents',
    'event',
    'getTimesEvent',
    'galleries',
    'categoriesMenu',
    'avalibilityHour',
    'avalibilityHourNoCommit',
    'selectedDate',
    'selectedHour',
    'selectedPeople',
    'preReservation',
    'preReservationEvent',
    'sendReservation',
    'send705',
    'confirmReservation',
    'banks',
    'branch',
    'reservationsUser',
    'reservationsList',
    'editReservation',
    'updateReservation',
    'cancelarReservation',
    'cancelarReservationEmail',
    'times',
    'reservationUserDate',
    'vendorsAssociates',
    'sendFormEvent',
    'getAvalibilityGroup',
    'getZones',
    'reservationDetailById',
    'deletePreReservation',
    'getReservationTypes',
    'locked',
    'getMaxPeople',
    'addGiftCard',
    'confirmGiftCard',
    'getGiftCardParams',
    'validateGiftCard',
    'formMenuDigital',
    'imageMenuDigital',
    'menusMenuDigital',
    'suscribeToKushi',
    'companionList',
    'companions',
    'companionUpdate',
    'companionDelete',
    'serverTime',
    'updatePreReservation',
    'actionListBannersMenu',
    'getIntegrations',
    'getIntegrationDefaults'
  ],
  mutations: [
    'setReservationTypes',
    'setAllEvents',
    'setEvent',
    'setLoader',
    'setDisabledOnLog',
    'setGalleries',
    'setCategoriesMenu',
    'setAvalibilityHour',
    'setSelectedDate',
    'setSelectedHour',
    'setSelectedPeople',
    'setSendReservation',
    'setSend705',
    'setPaymentType',
    'setIsFree',
    'setBanks',
    'setShowMenu',
    'setBranch',
    'setReservationsUser',
    'setReservationsList',
    'setReservationsExecuted',
    'setEditReservation',
    'setDataReservationEdit',
    'setCancelarReservation',
    'setMinimunPeoples',
    'setTimes',
    'setSection',
    'setShowModalLogin',
    'setShowModalReservationConfirm',
    'setShowModalUpdateUser',
    'setShowModalPolitica',
    'setLoadHour',
    'setReservationDayUser',
    'setShowCancelar',
    'setVendorAssociates',
    'setReservationEvent',
    'setAvalabilityGroup',
    'setIsAvalability',
    'setZones',
    'setInvite',
    'setSelectedZone',
    'setSelectedTable',
    'setSelectedAdult',
    'setSelectedBoy',
    'setSelectedBaby',
    'setSelectedTypeReservation',
    'setLocked',
    'setSelectedExperience',
    'setEventPrice',
    'setLoginProcessReservation',
    'setPopupAlertEvent',
    'setMenuIdBanner',
    'setListBannersMenu',
    'setExistBanner',
    'setIntegrations',
    'setIntegrationDefaults'
  ]
});
